import {
  getJDPcStyle,
  getJDMobileStyle,
  getShopSkuPrice,//获取商品价格
  getJDShelfState,//上下架状态
  getJDSkuImage,//查图片
  getJDisCod,//查是否支持货到付款
  getJDGoodsGift,//查询赠品信息
  getJDQueryFreight,//运费查询
  getJDSalesCheck,//商品可售验证
  getJDSimilarSku,//同类商品查询
  getJDGoodsStock,///查库存，根据SKU和地址
  getJDAreaLimit,// 查询当前sku购买是否有区域限制
  getShopSkuPriceMap,//价格批量查询
} from '@/api/mall/mallJD'
import { getJdGoodsDetail, listProducts, saveCollectGoods, deleteCollectGoods } from '@/api/mall/mallGoods'
import { listShops } from '@/api/mall/mallShop'
import { latestAddress, updateLatestAddress } from '@/api/mall/mallLogistics'
import { showImagePreview } from '@/utils/common'
import { countCartItems, listCartItems, addToCart, removeFromCart, updateCount } from '@/api/mall/mallOrder'
import { local, removeLocal } from '@/utils/session'
import { Toast } from 'vant'

const state = {
  goodsId: '',//商品id
  currentProductId: '',//货品id
  shopId: '',//店铺id
  skus: [],//同类商品
  skuIds: [],//同类商品id集合，不重复
  skusImgs:{},//同类商品下所有sku的所有图片
  goodsDetails:{},//当前goodsId下所有sku的详情
  skusStyle:{},//当前goodsId下所有sku的详情样式
  
  currentBuyNum: 1,//当前sku购买数量
  currentsSelectText: '1个',//当前sku已选规格描述
  currentsFreight: 0,//当前sku购买数量的运费
  goodsStock: {},// sku是否有货
  currentSkuStock: '',//当前sku是否有货
  currentSalesCheck: {},//当前商品是否可售校验
  currentUpDownStatus: 0,//当前商品上下架状态
  currentIsAreaRestrict: false,//当前商品是否有购买区域限制
  
  currentSku: '',//当前sku
  currentPrice: {},//当前sku商品价格
  lastAddress: {},//用户最后使用的地址
  jdSkuShow: false,//展示sku弹窗
  
  buyCartCount: 0,//购物车商品数量
  cartList: [],//购物车列表
  cartEditState: false,//购物车是否为编辑状态
  cartAllSelect: false,//购物车是否为全选
  cartEditAllSelect: false,//购物车编辑 是否为全选
  cartPriceMap: {},// shopId_sku: 价格--集合
  cartShopMap: {},// 店铺信息--集合
  cartGoodsMap: {},// 货品编号的详情--集合
  s_g_p: 0,//3个map 是否调用完毕，当=3时调用完毕
  cartTotalPrice: 0,//购物车已选商品总价
  cartTotalGoodsCount: 0,//购物车已选商品总件数
  
  isAreaRestrictMap: {},//是否有区域限制--map
  upDownStatusMap: {},//上下架状态--map
  skusStockMap: {},//库存--map
  salesCheckMap: {},//是否可售校验--map
  
}

const mutations = {
  change_shopId: (state, shopId) => {
    state.shopId = shopId
  },
  
  change_skuShow: (state, data) =>{
    state.jdSkuShow = data
  },
  change_currentsSelectText: (state, currentsSelectText) =>{
    state.currentsSelectText = currentsSelectText
  },
  commitSuks: (state, data) => {
    state.skus = Object.assign([], data)
  },
  commitGoodsDetail: (state, data) => {
    state.goodsDetails = Object.assign({}, data)
  },
  change_cartEditState: (state, status) => {
    state.cartEditState = status
  },
  pictureLook: (state, index) => {
    let imagesList = state.skusImgs[state.currentSku]
    let images = imagesList.map(item=>{
      return ('http://img13.360buyimg.com/n12/' + item.path)
    })
    let startPosition = index || 0;
    console.log(startPosition)
    showImagePreview({ images, startPosition })
  }
}

const actions = {
  initGoodsId: ({state}, goodsId)=>{
    return new Promise((resolve, reject) => {
      state.goodsId = goodsId
      state.currentSku = ''
      state.skus = []
      state.skuIds = []
      state.skusImgs = {}
      state.goodsStock = {}
      state.currentSalesCheck = {}
      state.currentPrice = {}
      state.lastAddress = {}
      window.setTimeout(()=>{
        resolve()
      },500)
    })
  },
  change_currentSku: ({ state, commit, dispatch }, currentSku) =>{
    if(currentSku!==state.currentSku){
      state.currentSku = currentSku
      dispatch('change_currentBuyNum', 1)
      dispatch('getJDShopSkuPrice', {
        jdSku: currentSku,
        shopId: state.shopId,
        fetchShareEarnAmount: true,
        fetchAgentEarnAmount: true,
        fetchIntegralDeductAmount: true
      })//商品价格
      
      dispatch('getJDSalesCheck', {skuIds: currentSku, queryExts: 'noReasonToReturn,thwa,isSelf,isJDLogistics,taxInfo'})//商品校验商品
      dispatch('getJDShelfState', {sku: currentSku })//商品上下架状态
      dispatch('getJDAreaLimit', {skuIds: currentSku })//查询商品区域限制
      
      dispatch('getJdGoodsDetail', {jdSku: currentSku, shopId: state.shopId})//获取当前sku详情
      // dispatch('getJDGoodsGift', {skuId: currentSku})//获取当前sku赠品
    }else {
      state.currentProductId = state.goodsDetails[currentSku].productId
    }
  },
  // 获取商品详情
  getJdGoodsDetail: ({ state, commit, dispatch }, req)=>{
    let obj = Object.assign({}, state.goodsDetails)
      return new Promise((resolve, reject) => {
        getJdGoodsDetail(req).then(res=>{
          if(res.code===200){
            obj[res.data.sku] = res.data
            state.currentProductId = res.data.productId
            state.goodsDetails = obj
            dispatch('getJDMobileStyle', state.currentSku)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    
  },
  // 获取样式
  getJDMobileStyle: ({ state, commit, dispatch }, sku)=>{
    let obj = Object.assign({}, state.skusStyle)
    if(!obj[sku]){
      return new Promise((resolve, reject) => {
        getJDMobileStyle({sku}).then(res=>{
          if(res.code===200 && res.data){
            obj[res.data.sku] = {cssContent: res.data.cssContent, jsContent: res.data.jsContent}
            state.skusStyle = obj
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  //查同类商品
  getJDSimilarSku: ({ state, commit, dispatch }, skuId)=>{
    return new Promise((resolve, reject) => {
      getJDSimilarSku({skuId}).then(res=>{
        if(res.code===200){
          state.skus = res.data || []
          let arr = []
          if(state.skus.length){
            let selectText = ''
            state.skus.forEach((item, i)=>{ //类目级别
              let saleAttrList = item.saleAttrList
              saleAttrList.forEach((item2, i2)=>{//按钮级别
                item2.skuIds = item2.skuIds.map(sku=>{
                  return (sku+'')
                })
                arr = arr.concat( item2.skuIds )
                if( item2.skuIds.indexOf(skuId) >-1){
                  state.skus[i]['selected'] = i2
                  selectText += (item2.saleValue+', ')
                }
              })
            });
            state.currentsSelectText = selectText + state.currentBuyNum +  '个'
            state.skuIds = arr = [...new Set(arr)]
            dispatch('getJDSkuImage', arr.join(','))
          }
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //初始化当前sku购买数量
  change_currentBuyNum: ({ state, commit, dispatch }, currentBuyNum) =>{
    console.log('------------', currentBuyNum )
    state.currentBuyNum = currentBuyNum
    let texts = state.skus.map(item=>{
      return item.saleAttrList[item.selected].saleValue
    })
    let text = ''
    if(texts.length){
      text = texts.join(', ')
    }
    state.currentsSelectText = (text ? (text + ', ') : '') + state.currentBuyNum + '个'
    dispatch('getJDQueryFreight', [{skuId: state.currentSku, num: currentBuyNum}])
    dispatch('getJDGoodsStock', {skuNums:[{skuId: state.currentSku, num: currentBuyNum}]})
    
  },
  //查图片
  getJDSkuImage: ({ state, commit, dispatch }, sku)=>{
    return new Promise((resolve, reject) => {
      getJDSkuImage({sku}).then(res=>{
        if(res.code===200){
          state.skusImgs = res.data
        }
        console.log('state.skusImgs', state.skusImgs)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //查当前售价
  getJDShopSkuPrice: ({ state, commit, dispatch }, req)=>{
    return new Promise((resolve, reject) => {
      getShopSkuPrice(req).then(res=>{
        if(res.code===200){
          state.currentPrice = res.data || {
            agentSellEnabled: false,
            sellPrice: '',
            displayOriginalPrice: '',
            goodsAgentEarnAmountL1: 0,
            goodsAgentEarnAmountL2: 0,
            goodsAgentEarnAmountL3: 0,
            goodsShareEarnAmount: 0,
            integralDeductCashAmount: 0
          }
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //校验商品是否可售
  getJDSalesCheck: ({ state, commit, dispatch }, data) => {
    let req = Object.assign({}, data)
    return new Promise((resolve, reject) => {
      getJDSalesCheck(req).then(res=>{
        if(res.code===200 && res.data[0]){
          state.currentSalesCheck = Object.assign({}, res.data[0])
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //查询是否上下架
  getJDShelfState: ({ state, commit, dispatch }, data) => {
    let req = Object.assign({}, data)
    return new Promise((resolve, reject) => {
      getJDShelfState(req).then(res=>{
        if(res.code===200 && res.data[0]){
          state.currentUpDownStatus = res.data[0].state
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //查询当前sku是否有购买区域限制
  getJDAreaLimit: ({ state, commit, dispatch }, data) => {
    let req = Object.assign({}, data)
    let { provinceJdId, cityJdId, countyJdId, townJdId } = state.lastAddress
    req.province = provinceJdId
    req.city = cityJdId
    req.county = countyJdId
    req.town = townJdId || 0
    
    if(!req.county){
      console.error('county, 无位置数据', req.county)
      return false
    }
    return new Promise((resolve, reject) => {
      getJDAreaLimit(req).then(res=>{
        if(res.code===200 && res.data[0]){
          state.currentIsAreaRestrict = res.data[0].isAreaRestrict
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //查当前sku库存
  getJDGoodsStock:({ state, commit, dispatch }, data) => {
    let req = Object.assign({}, data)
    let { provinceJdId, cityJdId, countyJdId, townJdId } = state.lastAddress
    
    let area = '';
    provinceJdId && (area = area + provinceJdId);
    cityJdId && (area+=('_'+cityJdId));
    countyJdId && (area+=('_'+countyJdId));
    townJdId && (area+=('_'+townJdId));
    req['area'] = area;
    if(!area){
      console.error('area, 无位置数据', area)
      return false
    }
    return new Promise((resolve, reject) => {
      getJDGoodsStock(req).then(res=>{
        if(res.code===200){
          let obj = Object.assign({}, state.goodsStock)
          if(res.data.length){
            let data = res.data
            data.map(item=>{
              obj[item.skuId] = item
            })
            state.goodsStock = obj
            state.currentSkuStock = state.goodsStock[state.currentSku].stockStateId
          }
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //查询当前商品赠品
  getJDGoodsGift: ({ state, commit, dispatch }, data) => {
    let { provinceJdId, cityJdId, countyJdId, townJdId } = state.lastAddress
    let req = {
      skuId: data.skuId,
      province: provinceJdId,
      city: cityJdId,
      county: countyJdId,
    }
    if(townJdId){
      req.town = townJdId
    }
    return new Promise((resolve, reject) => {
      getJDGoodsGift(req).then(res=>{
        if(res.code===200){
        
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  //查询用户最后使用地址
  getLatestAddress: ({ state, commit, dispatch }, flag) => {
    return new Promise((resolve, reject) => {
      latestAddress({}).then(res=>{
        if(res.code===200){
          state.lastAddress = res.data
          if(flag){
            dispatch('getJDGoodsStock', {skuNums: [{skuId: state.currentSku, num: state.currentBuyNum}]} )
          }
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //修改用户最后使用地址
  updateLatestAddress: ({ state, commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      updateLatestAddress(req).then(res=>{
        if(res.code===200){
          // state.lastAddress = res.data
          dispatch('getLatestAddress', true)
          //获取运费
          dispatch('getJDQueryFreight', [{skuId: state.currentSku, num: state.currentBuyNum}])
          dispatch('getJDAreaLimit', {skuIds: state.currentSku })//查询商品区域限制
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //查询运费
  getJDQueryFreight: ({state, commit, dispatch}, req)=>{
    let sku = Object.assign([],req)
    let { provinceJdId, cityJdId, countyJdId, townJdId } = state.lastAddress
    let reqData = {
      paymentType: 4,
      province: provinceJdId,
      city: cityJdId,
      county: countyJdId,
      town: townJdId || 0,
      sku
    }
    return new Promise((resolve, reject) => {
      getJDQueryFreight(reqData).then(res=>{
        if(res.code===200){
          state.currentsFreight = res.data.freight || 0;
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //修改收藏状态
  changeGoodsCollect:({state, commit, dispatch }, data)=>{
    if(data.isCollected){ // 收藏商品
      return new Promise((resolve, reject) => {
        saveCollectGoods({goodsId: data.goodsId, shopId: state.shopId}).then(res=>{
          if(res.code===200){
            window.setTimeout(()=>{
              dispatch('getJdGoodsDetail', {jdSku: state.currentSku, shopId: state.shopId })
            },200)
            Toast({message: '已收藏',duration: 600})
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }else { // 取消收藏商品
      return new Promise((resolve, reject) => {
        deleteCollectGoods({goodsId: data.goodsId, shopId: state.shopId}).then(res=>{
          if(res.code===200){
            window.setTimeout(()=>{
              dispatch('getJdGoodsDetail', {jdSku: state.currentSku, shopId: state.shopId })
            },200)
            Toast({message: '已取消收藏', duration: 600})
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
    
    
  },
  //查询当前购物车商品数量
  getBuyCartCount: ({state, commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      countCartItems().then(res=>{
        if(res.code===200){
          state.buyCartCount = res.data.cnt || 0
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //获取购物车列表数据***************///
  getListCartItems: ({state, commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      listCartItems().then(res=>{
        if(res.code===200){
          let list = res.data || []
          if(list.length){
            let shopReq = {shopIds: []}
            let goodsReq = {productIds: []}
            let priceReq = {list: []}
            let areaLimitReq = {skuIds: ''} //区域限制
            let shelfStateReq = {sku: ''} // 上下架状态
            let goodsStockReq = {skuNums: []} // 库存
            let salesChecReq = {skuIds: '', queryExts: 'noReasonToReturn,thwa,isSelf,isJDLogistics,taxInfo'} // 是否可售校验
            list.map(item=>{
              shopReq.shopIds.push(item.shopId)
              item.shopItems.map(item2=>{
                goodsReq.productIds.push(item2.productId)
                priceReq.list.push({shopId: item.shopId, jdSku: item2.productCode})
                areaLimitReq.skuIds += item2.productCode+',' //区域限制
                shelfStateReq.sku += item2.productCode+',' //上下架状态
                goodsStockReq.skuNums.push({skuId: item2.productCode, num: item2.productCount}) //库存
                salesChecReq.skuIds += item2.productCode+',' //是否可售校验
              })
            })
            dispatch('listShops', shopReq)//查询店铺信息
            dispatch('listProducts', goodsReq)//查询商品信息
            dispatch('listJDAreaLimit', areaLimitReq) //区域限制
            dispatch('getShopSkuPriceMap', priceReq)//查询价格
            dispatch('listJDShelfState', shelfStateReq) //上下架状态
            dispatch('listJDGoodsStock', {req: goodsStockReq, addCount: true}) //库存
            dispatch('listJDSalesCheck', salesChecReq) //是否可售校验
            let timer = window.setInterval(()=>{
              if(state.s_g_p===7){
                let cartList = list.map(item=>{
                  item.mapShopInfo = state.cartShopMap[item.shopId]//店铺信息
                  let shopItems = item.shopItems.map(item2=>{
                    item2.mapPrice = state.cartPriceMap[item.shopId+'_'+item2.productCode]//价格信息
                    item2.mapProductDetail = state.cartGoodsMap[item2.productId]//商品信息
                    item2.mapIsAreaRestrict = state.isAreaRestrictMap[item2.productCode]//是否区域限制
                    item2.mapUpDownStatus = state.upDownStatusMap[item2.productCode]//是否上下架
                    item2.mapSkusStock = state.skusStockMap[item2.productCode]//库存
                    item2.mapSalesCheck = state.salesCheckMap[item2.productCode]//可售校验
                    
                    return item2
                  })
                  item.shopItems = shopItems
                  return item
                })
                
                
                dispatch('mapBuyCartSelect', cartList)
                window.clearInterval(timer)
                timer = null
                state.s_g_p = 0
              }
            },30)
          }else {
            dispatch('mapBuyCartSelect', [])
          }
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //加入购物车
  addBuyCart: ({state, commit, dispatch}, data) => {
    let items = data.items.map(item=>{
      let data = Object.assign({}, item)
      return data
    })
    let req = {items}
    return new Promise((resolve, reject) => {
      addToCart(req).then(res=>{
        if(res.code===200){
          //设置默认选中
          let buyCartSelected = local('buyCartSelected') || {}
          
          items.map(item=>{
            let hasShopIdLocal = buyCartSelected[item.shopId] || {shopItems: {},shopSelected: false}
            hasShopIdLocal.shopItems[item.productCode] = true
            buyCartSelected[item.shopId] = hasShopIdLocal
          })
          local('buyCartSelected', buyCartSelected)
          
          dispatch('getBuyCartCount')
          Toast({message: '已添加至购物车'})
          commit('change_skuShow', false)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //修改购物车商品数量
  updateCount: ({state, commit, dispatch}, data) => {
    // console.log(data)
    let req = Object.assign({}, data)
    return new Promise((resolve, reject) => {
      updateCount(req).then(res=>{
        if(res.code===200){
          let reqData = {}
          let arr = Object.assign([], state.cartList)
          let cartList = arr.map(item=>{
            let shopItems = item.shopItems.map(item2=>{
              if(item2.cartId===req.cartId){
                item2.productCount = req.productCount
                reqData = {skuNums: [{skuId: item2.productCode, num: item2.productCount}]}
              }
              return item2
            })
            item.shopItems = shopItems
            return item
          })
          state.cartList = cartList
          dispatch('changeBuyCartEditSelect', state.cartList)
          dispatch('listJDGoodsStock', {req: reqData, addCount: false}) //库存
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //移除购物车的商品
  removeBuyCart: ({state, commit, dispatch}, data) => {
    let req = {cartIds: Object.assign([], data)}
    return new Promise((resolve, reject) => {
      removeFromCart(req).then(res=>{
        if(res.code===200){
          dispatch('getListCartItems')
          commit('change_cartEditState', false)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 遍历 购物车勾选状态
  mapBuyCartSelect: ({state, commit, dispatch}, arr)=>{
    let count = 0
    let totalPrice = 0, totalGoodsCount = 0;
    let list = Object.assign([], arr)
    let buyCartSelected = local('buyCartSelected') || {}
    let data = list.map(item=>{
      let hasShopIdLocal = buyCartSelected[item.shopId]
      let skuSelect = 0
      item.shopItems = item.shopItems.map(goodsItem=>{
        goodsItem.skuIdSelected = (hasShopIdLocal && buyCartSelected[item.shopId].shopItems[goodsItem.productCode]!==undefined) ? buyCartSelected[item.shopId].shopItems[goodsItem.productCode] : false
        if(goodsItem.skuIdSelected){
          skuSelect++
          totalPrice += state.cartPriceMap[item.shopId+'_'+goodsItem.productCode].sellPrice * goodsItem.productCount
          totalGoodsCount += goodsItem.productCount
        }
        return goodsItem
      })
      if(skuSelect===item.shopItems.length){
        item.shopSelected = true
      }else {
        item.shopSelected = false
      }
      if(item.shopSelected){count++}
      return item
    })
    state.cartTotalPrice = totalPrice
    state.cartTotalGoodsCount = totalGoodsCount
    state.cartAllSelect = (count===arr.length)
    state.cartList = data
  },
  // 设置购物车勾选状态
  changeBuyCartSelect: ({state, commit, dispatch}, data)=>{
    // console.log('data', data)
    let obj = local('buyCartSelected') || {};
    data.map(item=>{
      obj[item.shopId] = {}
      obj[item.shopId].shopSelected = item.shopSelected
      obj[item.shopId].shopItems = {}
      item.shopItems.map(item2=>{
        obj[item.shopId].shopItems[item2.skuId] = item2.skuIdSelected
      })
    })
    local('buyCartSelected', obj)
    dispatch('mapBuyCartSelect', state.cartList)
  },
  // 设置处理状态的勾选状态
  changeBuyCartEditSelect: ({state, commit, dispatch}, data) => {
    console.log('changeBuyCartEditSelect', data)
    let count = 0
    let arr = Object.assign([], data)
    let cartList = Object.assign([], state.cartList)
    let dataList = []
    cartList.forEach((item, i)=>{
      item.editShopSelected = arr[i].editShopSelected || false;
      let array = []
      item.shopItems.forEach((goodsItem, g)=>{
        goodsItem.mapSkusStock = state.skusStockMap[goodsItem.productCode];
        goodsItem.editSkuIdSelected = arr[i].shopItems[g].editSkuIdSelected || false;
        array.push(goodsItem)
      })
      dataList.push(item)
      if(item.editShopSelected){count++}
    })
    dispatch('mapBuyCartSelect', dataList)
    console.log(count ===cartList.length)
    state.cartEditAllSelect = (count ===cartList.length )
  },
  //------------------------------//
  //批量查询店铺信息
  listShops: ({state, commit, dispatch}, req) => {
    // console.log('listShops--data:', req)
    let cartShopMap = Object.assign({}, state.cartShopMap)
    return new Promise((resolve, reject) => {
      listShops(req).then(res=>{
        if(res.code===200){
          let data = res.data
          Object.keys(data).forEach(key=>{
            cartShopMap[key] = data[key]
          })
          state.cartShopMap = cartShopMap
          state.s_g_p++
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //批量查询商品信息
  listProducts: ({state, commit, dispatch}, req) => {
    // console.log('listProducts--data:', req)
    let cartGoodsMap = Object.assign({}, state.cartGoodsMap)
    return new Promise((resolve, reject) => {
      listProducts(req).then(res=>{
        if(res.code===200){
          let data = res.data
          Object.keys(data).forEach(key=>{
            cartGoodsMap[key] = data[key]
          })
          state.cartGoodsMap = cartGoodsMap
          state.s_g_p++
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //批量查询商品价格信息
  getShopSkuPriceMap: ({state, commit, dispatch}, req) => {
    // console.log('getShopSkuPriceMap--data:', req)
    let cartPriceMap = Object.assign({}, state.cartPriceMap)
    return new Promise((resolve, reject) => {
      getShopSkuPriceMap(req).then(res=>{
        if(res.code===200){
          let data = res.data
          Object.keys(data).forEach(key=>{
            cartPriceMap[key] = data[key] || {sellPrice: -1,displayOriginalPrice: -1}
          })
          state.cartPriceMap = cartPriceMap
          state.s_g_p++
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //批量查询是否是否有区域限制
  listJDAreaLimit: ({ state, commit, dispatch }, data) => {
    let req = Object.assign({}, data)
    let { provinceJdId, cityJdId, countyJdId, townJdId } = state.lastAddress
    req.province = provinceJdId
    req.city = cityJdId
    req.county = countyJdId
    req.town = townJdId || 0
    if(!req.county){
      console.error('county, 无位置数据', req.county)
      return false
    }
    let isAreaRestrictMap = Object.assign({}, state.isAreaRestrictMap)
    return new Promise((resolve, reject) => {
      getJDAreaLimit(req).then(res=>{
        if(res.code===200){
          let data = res.data
          data.forEach(item=>{
            isAreaRestrictMap[item.skuId] = item.isAreaRestrict
          })
          state.isAreaRestrictMap = isAreaRestrictMap
          state.s_g_p++
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //批量查询是否上下架
  listJDShelfState: ({ state, commit, dispatch }, req) => {
    let upDownStatusMap = Object.assign({}, state.upDownStatusMap)
    return new Promise((resolve, reject) => {
      getJDShelfState(req).then(res=>{
        if(res.code===200){
          let data = res.data
          data.forEach(item=>{
            upDownStatusMap[item.sku] = item
          })
          state.upDownStatusMap = upDownStatusMap
          state.s_g_p++
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //批量查sku库存
  listJDGoodsStock:({ state, commit, dispatch }, reqData) => {
    let req = Object.assign({}, reqData.req)
    let { provinceJdId, cityJdId, countyJdId, townJdId } = state.lastAddress
    let area = '';
    provinceJdId && (area = area + provinceJdId);
    cityJdId && (area+=('_'+cityJdId));
    countyJdId && (area+=('_'+countyJdId));
    townJdId && (area+=('_'+townJdId));
    req['area'] = area;
    if(!area){
      console.error('area, 无位置数据', area)
      return false
    }
    let skusStockMap = Object.assign({}, state.skusStockMap)
    return new Promise((resolve, reject) => {
      getJDGoodsStock(req).then(res=>{
        if(res.code===200){
          let data = res.data
          data.forEach(item=>{
            skusStockMap[item.skuId] = item
          })
          state.skusStockMap = skusStockMap
          // console.log('state.skusStockMap', state.skusStockMap)
          if(reqData.addCount){
            state.s_g_p++
          }else {
            dispatch('changeBuyCartEditSelect', state.cartList)
          }
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //校验商品是否可售
  listJDSalesCheck: ({ state, commit, dispatch }, data) => {
    let req = Object.assign({}, data)
    let salesCheckMap = Object.assign({}, state.salesCheckMap)
    return new Promise((resolve, reject) => {
      getJDSalesCheck(req).then(res=>{
        if(res.code===200){
          let data = res.data
          data.forEach(item=>{
            salesCheckMap[item.skuId] = item
          })
          state.salesCheckMap = salesCheckMap
          state.s_g_p++
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}
